import { createApp } from 'vue'
import App from './App.vue'
import '@/assets/main.css'

// 样式初始化一般放在最前面
import 'reset-css'
// element plus
import ElementPlus from 'element-plus'
// element icons
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// element css
import 'element-plus/dist/index.css'
// element dark(内置暗黑模式)
import 'element-plus/theme-chalk/dark/css-vars.css'
// vue Router
import router from '@/routers/index'
// vue i18n
import I18n from '@/languages/index'
// custom directives
import directives from '@/directives/index'
// errorHandler
import errorHandler from '@/utils/errorHandler'
import VueAwesomeSwiper from 'vue-awesome-swiper'
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}

app.config.errorHandler = errorHandler

// 注册element Icons组件
// Object.keys(Icons).forEach(key => {
// 	app.component(key, Icons[key as keyof typeof Icons]);
// });

app.use(VueAwesomeSwiper).use(router).use(I18n).use(directives).use(ElementPlus).mount('#app')
